import { FormBase } from 'core/components';

export default class FacilityAdditionalContactBulkCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'contacts',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.CONTACTS',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.CONTACTS_PLACEHOLDER',
                    type:'string',
                    rules: 'required'
                },
            ],
        };
    }
}
